import { createGlobalStyle } from 'styled-components';

const GlobalStyles = createGlobalStyle`
  :root {
    --color-primary: #1e88e5; /* Основной синий цвет */
    --color-secondary: #ff9800; /* Оранжевый для акцентов и CTA */
    --color-text: #333333;
    --color-text-light: #666666;
    --color-background: #ffffff;
    --color-background-alt: #f5f7fa;
    --color-border: #e0e0e0;
    
    --font-main: 'Montserrat', sans-serif;
    
    --shadow-sm: 0 2px 4px rgba(0, 0, 0, 0.05);
    --shadow-md: 0 4px 8px rgba(0, 0, 0, 0.1);
    --shadow-lg: 0 8px 16px rgba(0, 0, 0, 0.15);
    
    --border-radius-sm: 4px;
    --border-radius-md: 8px;
    --border-radius-lg: 12px;
    
    --spacing-xs: 4px;
    --spacing-sm: 8px;
    --spacing-md: 16px;
    --spacing-lg: 24px;
    --spacing-xl: 32px;
    --spacing-xxl: 48px;
    
    --transition-fast: 0.2s ease;
    --transition-normal: 0.3s ease;
    --transition-slow: 0.5s ease;
    
    --container-width: 1200px;
    --container-padding: 20px;
  }
  
  * {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
  }
  
  html {
    font-size: 16px;
    scroll-behavior: smooth;
  }
  
  body {
    font-family: var(--font-main);
    color: var(--color-text);
    background-color: var(--color-background);
    line-height: 1.6;
    overflow-x: hidden;
  }
  
  a {
    text-decoration: none;
    color: var(--color-primary);
    transition: color var(--transition-fast);
    
    &:hover {
      color: var(--color-secondary);
    }
  }
  
  button {
    font-family: var(--font-main);
    cursor: pointer;
    border: none;
    outline: none;
  }
  
  img {
    max-width: 100%;
    height: auto;
  }
  
  h1, h2, h3, h4, h5, h6 {
    font-weight: 700;
    line-height: 1.2;
    margin-bottom: var(--spacing-md);
  }
  
  h1 {
    font-size: 2.5rem;
    
    @media (max-width: 768px) {
      font-size: 2rem;
    }
  }
  
  h2 {
    font-size: 2rem;
    
    @media (max-width: 768px) {
      font-size: 1.75rem;
    }
  }
  
  h3 {
    font-size: 1.5rem;
    
    @media (max-width: 768px) {
      font-size: 1.25rem;
    }
  }
  
  p {
    margin-bottom: var(--spacing-md);
  }
  
  section {
    padding: var(--spacing-xl) 0;
  }
  
  .container {
    max-width: var(--container-width);
    padding: 0 var(--container-padding);
    margin: 0 auto;
  }
  
  .btn {
    display: inline-block;
    padding: var(--spacing-sm) var(--spacing-lg);
    border-radius: var(--border-radius-md);
    font-weight: 600;
    text-align: center;
    transition: all var(--transition-normal);
    
    &-primary {
      background-color: var(--color-primary);
      color: white;
      
      &:hover {
        background-color: darken(var(--color-primary), 10%);
        transform: translateY(-2px);
        box-shadow: var(--shadow-md);
      }
    }
    
    &-secondary {
      background-color: var(--color-secondary);
      color: white;
      
      &:hover {
        background-color: darken(var(--color-secondary), 10%);
        transform: translateY(-2px);
        box-shadow: var(--shadow-md);
      }
    }
    
    &-outline {
      background-color: transparent;
      border: 2px solid var(--color-primary);
      color: var(--color-primary);
      
      &:hover {
        background-color: var(--color-primary);
        color: white;
        transform: translateY(-2px);
      }
    }
  }
  
  .text-center {
    text-align: center;
  }
  
  .mb-1 {
    margin-bottom: var(--spacing-sm);
  }
  
  .mb-2 {
    margin-bottom: var(--spacing-md);
  }
  
  .mb-3 {
    margin-bottom: var(--spacing-lg);
  }
  
  .mb-4 {
    margin-bottom: var(--spacing-xl);
  }
  
  .mt-1 {
    margin-top: var(--spacing-sm);
  }
  
  .mt-2 {
    margin-top: var(--spacing-md);
  }
  
  .mt-3 {
    margin-top: var(--spacing-lg);
  }
  
  .mt-4 {
    margin-top: var(--spacing-xl);
  }
`;

export default GlobalStyles; 